// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"409c1325","230":"c36eb7d8","241":"306640d9","272":"62d16b88","345":"2e233edf","730":"b5fb256a","785":"f45a1a93"}[chunkId] + ".chunk.css";
};